import React from 'react'
import styles from './styles.scss'

class Category extends React.Component {
  render() {
    const { children } = this.props
    return (
      <div className={styles.container}>
      {children}
      </div>
    )
  }
}

export default Category


// WEBPACK FOOTER //
// src/pages/CompanyIndex/Companies/Company/Category/index.jsx